import type { PersonRole } from "@/shared/roles";

/**
 * What Home's company card reads: attendance for an Admin or a Manager, overdue invoices for an
 * Admin. Apart from the card, which Home's loader would otherwise bring into every first load.
 */
export function companyCardReads(
  role: PersonRole,
  on: { readonly attendance: boolean; readonly invoices: boolean },
) {
  return {
    attendance: (role === "admin" || role === "manager") && on.attendance,
    invoices: role === "admin" && on.invoices,
  };
}
